import React, { Component } from 'react'
import { getResorts } from '../../store/reducers';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

function withHomeResorts(WrappedComponent){
    class HomeResorts extends Component {

        componentWillMount() {
            if(!this.props.resorts){
                this.props._get_resorts()
            }
        }

        render() {
            const { resorts, ...restProps } = this.props
            const items = resorts ? resorts.resorts : null
            const title = resorts ? resorts.title : null
            return (
                items ? <WrappedComponent items={ items } title={ title } {...restProps} /> : <div></div>
            ) 
        }
    }
    return withRouter(connect( 
        (state, ownProps) =>({
            resorts: state.app.resorts
        }),
        dispatch => { 
        return { 
            _get_resorts: (payload) => { dispatch(getResorts(payload)) } ,
        } 
        }
    )(HomeResorts));
}

export default withHomeResorts



// WEBPACK FOOTER //
// ./src/containers/homeresorts/index.js